/**
 * @param object editorStyle
 * @return boolean
 */
export function isBold(editorStyle) {
    return editorStyle.fontWeight != 'normal';
}

/**
 * @param object editorStyle
 * @return boolean
 */
export function isItalic(editorStyle) {
    return editorStyle.fontStyle != 'normal';
}


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ChatEditorOwn/utils.js